<template>
  <div class="grid-container full">
    <div class="grid-x top-section">
      <div class="small-1 cell text-left">
        <div
          v-if="showBurgerMenu"
          class="burger-cont"
        >
          <rare-hamburger-icon />
          <rare-company-menu />
        </div>
      </div>
      <div class="small-10 cell text-center">
        <div v-if="computedTitle === 'logo'">
          <img
            src="@/assets/img/logo.png"
            class="header-logo"
            alt="Logo"
          >
        </div>
        <h1
          v-else
          class="header-title"
        >
          {{ computedTitle }}
        </h1>
      </div>
      <div class="small-1 cell text-right">
        <div
          v-if="showLogoutIcon"
          class="logout-cont"
        >
          <rare-icon-logout
            class="logout-icon"
            @emmitClick="emmitLogout"
          />
        </div>
        <div v-else>
&nbsp;
        </div>
      </div>
    </div>

    <div class="grid-x bottom-section">
      <div class="small-1 cell text-center">
&nbsp;
      </div>
      <div class="small-10 cell text-center">
        <ul
          v-if="showNavigationLinks"
          class="navigation"
        >
          <router-link
            tag="li"
            to="/summary"
          >
            Summary
          </router-link>
          <router-link
            tag="li"
            to="/industry-overview"
          >
            Industry Overview
          </router-link>
          <!--<router-link tag="li" to="/heat-map">Heat Map</router-link>-->
          <router-link
            tag="li"
            to="/performance-index"
          >
            Performance Index
          </router-link>
        </ul>
      </div>
      <div class="small-1 cell text-right">
        <rare-icon-download
          v-if="showDownloadIcon"
          class="download-icon"
          @emmitClick="emmitDownload"
        />
        <div v-else>
&nbsp;
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import RareHamburgerIcon from '../icons/RareHamburgerIcon.vue';
import RareIconDownload from '../icons/RareIconDownload.vue';
import RareIconLogout from '../icons/RareIconLogout.vue';

import RareClientMenu from '../controls/RareClientMenu.vue';

export default {
  name: 'DashboardHeader',
  components: {
    'rare-hamburger-icon': RareHamburgerIcon,
    'rare-icon-download': RareIconDownload,
    'rare-icon-logout': RareIconLogout,
    'rare-company-menu': RareClientMenu,
  },
  props: {
    // Title is now a computed prop from the central store.
  },
  computed: {
    computedTitle() {
      return this.$store.getters.getDisplayNameFromUsername(this.$store.getters.pageTitle);
    },
    showBurgerMenu() {
      return this.$store.getters.showBurgerMenu;
    },
    showLogoutIcon() {
      return this.$store.getters.showLogoutIcon;
    },
    showDownloadIcon() {
      return this.$store.getters.showDownloadIcon;
    },
    showNavigationLinks() {
      return this.$store.getters.showDownloadIcon;
    },
  },
  methods: {
    emmitDownload() {
      this.$emit('emmitDownload');
    },
    emmitLogout() {
      this.$emit('emmitLogout');
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .header-logo {
    display: inline-block;
    margin-top: 19px;
    width: 120px;
  }

  .top-section {
    background-color: $header-dark-blue;
    color: $white-text;
    height: 60px;
  }

  .bottom-section {
    background-color: $header-light-blue;
    color: $white-text;
    height: 72px;
    box-shadow: inset 0px -5px 10px 0px rgba(20, 27, 33, 0.4);
  }

  .navigation {
    height: 72px;
  }

  .navigation li {
    cursor: pointer;
    display: inline-block;
    height: 72px;
    line-height: 72px;
    padding: 0 30px 0 30px;
  }

  .navigation li.router-link-active {
    border-bottom: 4px solid $green-highlight;
    color: $green-highlight;
  }

  .navigation li:hover {
    border-bottom: 4px solid $white-text;
  }

  .download-icon {
    margin-right: 30px;
    margin-top: 16px;
  }

  .logout-icon {
    margin-right: 22px;
    margin-top: 21px;
  }

  .logout-cont {
    border-left: 1px solid $header-light-blue;
    display: inline-block;
    height: 60px;
    width: 72px;
  }

</style>
